import MediaTextarea from './mediaTextarea'

$('.js__mediaTextarea').each(function() {
  const $textarea = $(this).find('textarea').remove()
  const text = $textarea.val()

  $(this).reactify(MediaTextarea, { text })
})
